import { ControllerRenderProps, UseFormRegister } from "react-hook-form"
import { CityPublic } from "../../client"
import { Combobox, HStack, Portal, Span, Spinner, useListCollection } from "@chakra-ui/react"
import { useEffect } from "react"

interface CityFieldProps {
  collection: ReturnType<typeof useListCollection<CityPublic>>["collection"]
  loading: boolean
  field: ControllerRenderProps<any, string>
  onInputChange: (value: string) => void
  register: UseFormRegister<any>
  isRequired: boolean
}

const CityField = ({
  collection,
  loading,
  field,
  onInputChange,
  register,
  isRequired
}: CityFieldProps) => {
    useEffect(() => {
        if (field.value) {
            const matchedItem = collection.items.find(item => item.name === field.value || item.postcode === field.value)

            if (matchedItem) {
                field.onChange(matchedItem.name)
            }
        }
    }, [field.value])

    const onValueChange = (e: string) => {
        if(e) {
            const city = e.split("- ")[1]
            field.onChange(city)
        } else {
            field.onChange(e || "")
        }
    }

    return (
        <Combobox.Root
            collection={collection}
            allowCustomValue={true}
            openOnClick={collection.items.length > 0 ? true : false}
            onValueChange={({ value }) => { onValueChange(value[0])}}
            onInputValueChange={(e) => onInputChange(e.inputValue)}
        >
            <Combobox.Control>
                <Combobox.Input 
                    placeholder="Ort eingeben"
                    {...register(field.name, {
                        required: isRequired ? "Ort wird benötigt" : false,
                        maxLength: {
                            value: 30,
                            message: "Ort darf maximal 30 Zeichen lang sein",
                        }
                    })}
                    onChange={(e) => field.onChange(e.target.value)}
                />

                <Combobox.IndicatorGroup>
                    <Combobox.ClearTrigger />
                    <Combobox.Trigger />
                </Combobox.IndicatorGroup>
            </Combobox.Control>

            <Portal>
                <Combobox.Positioner zIndex="10000 !important">
                    <Combobox.Content>
                        {loading ? (
                            <HStack p="2">
                                <Spinner size="xs" borderWidth="1px" />
                                <Span>Laden...</Span>
                            </HStack>
                        ) : (
                            collection.items.map((item, i) => (
                                <Combobox.Item key={i} item={item}>
                                    {item.postcode} - {item.name}
                                    <Combobox.ItemIndicator />
                                </Combobox.Item>
                            ))
                        )}
                    </Combobox.Content>
                </Combobox.Positioner>
            </Portal>
        </Combobox.Root>
    )
}

export default CityField
